var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"ct-chart",style:({ height: this.height + 'px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }